export default __webpack_public_path__ + "static/media/main-big.5caf50c9.jpg";